import { Component, OnInit } from '@angular/core';
import { AuthService } from '../shared/services/auth.service';

@Component({
  selector: 'my-home',
  template: require('./home.component.html'),
  styles: [require('./home.component.scss')]
})

export class HomeComponent implements OnInit {
  constructor(
    public authService: AuthService
  ) {};

  ngOnInit(){
    if(this.detectUrl()) {
      this.authService.login();
    }
  }

  detectUrl() {
    if (this.authService.returnUrl.indexOf('/auth/okta') === -1 &&
      this.authService.returnUrl.indexOf('/user/detect') === -1 &&
      this.authService.returnUrl.indexOf('/auth/activation') === -1 &&
      this.authService.returnUrl.indexOf('/auth/password-reset')=== -1) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./src/app/home/home.component.ts